import styled from 'styled-components';

export const TextRed = styled.div`
    color: ${({ theme }) => theme.red300};
`;
